import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { fontSizes, spacing } from 'syf-component-library/defaultTheme';
import { Button } from 'syf-component-library/ui/atoms';
import Collapse from 'syf-component-library/ui/atoms/Collapse';
import { Grid } from 'syf-component-library/ui/patterns';
import { Body } from 'syf-component-library/ui/typography';
import { colors } from '../../../../defaultTheme';
export const AutopayCollapseBanner = styled.div `
  background-color: ${colors.lightGrey};
  border-bottom: 1px solid ${colors.mediumGrey};
  position: relative;
`;
export const AutopayStatusText = styled(Body) `
  @media ${mediaQueries.lessThanSmall} {
    white-space: pre-line;
  }
`;
export const CTAButton = styled(Button) `
  margin: 0;
  padding: 0;
  font-size: ${fontSizes.root}px;
`;
export const AutopayCollapseBannerContent = styled(Grid) `
  position: relative;
`;
export const CollapseWrapper = styled(Collapse) `
  position: relative;
  z-index: 1;
`;
export const CollapseIcon = styled(FontAwesomeIcon) `
  position: absolute;
  right: ${spacing.medium}px;
  font-size: ${fontSizes.medium}px;
  color: ${colors.black};
`;
export const AutopayUnavailableWrapper = styled.div `
  display: flex;
  align-items: center;
`;
export const AutopayIconWrapper = styled.div `
  height: 48px;
  width: 48px;
`;
